import { render, staticRenderFns } from "./callForward.vue?vue&type=template&id=3380aeba&scoped=true&"
import script from "./callForward.vue?vue&type=script&lang=js&"
export * from "./callForward.vue?vue&type=script&lang=js&"
import style0 from "./callForward.vue?vue&type=style&index=0&id=3380aeba&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3380aeba",
  null
  
)

export default component.exports